export const DISCOUNTS_TYPES = {
  PERCENTAGE: 'percentage',
  DISCOUNT: 'discount',
};
